module.exports = __webpack_public_path__ + "static/SittiRizaliyanaMD-675ad1aeef4fd5b572121ccd5517951b.jpg";